module.exports = __webpack_public_path__ + "img/virma_logo_green.10f59160.png";